import React, {useEffect} from "react";
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {LoggedInView} from "../common/LoggedInView";
import Breadcrumbs from "../common/Breadcrumbs";
import {BreadcrumbLink} from "../../models/BreadcrumbLink";
import {
    getCurrentInquiry,
    updateInquiry,
    resetMarkAnsweredStatus,
    markAnswered
} from "../../store/reducers/InquiriesSlice";
import {ModifyInquiryFormProps} from "./ModifyInquiryScreen";
import {RequestStatus} from "../../utils/Enums";
import ElogTextarea from "../common/form/ElogTextarea";
import ElogInput from "../common/form/ElogInput";
import {FormikProvider, useFormik, Form} from "formik";
import {updateOfflineReason} from "../../store/reducers/OfflineReasonsSlice";

interface ModifyInquiryScreenProps {}

interface MarkAnsweredScreenProps {}

export interface MarkAnsweredFormProps {
    user: number;
    expires_at: string;
}

export const MarkAnsweredScreen: React.FC<MarkAnsweredScreenProps> = () => {

    const {id} = useParams();

    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const inquiriesState = useAppSelector((state) => state.inquiries);

    const requestStatus: RequestStatus = inquiriesState.markAnsweredStatus;

    const breadcrumbLinks: BreadcrumbLink[] = [
        { text: "Päringud", url: "/inquiries" },
        { text: "Märgi vastatuks", url: `/inquiries/${id}/mark-answered` },
    ];

    useEffect(() => {
        if (requestStatus === RequestStatus.Success) {
            dispatch(resetMarkAnsweredStatus());
            navigate(breadcrumbLinks[0].url);
        }
    }, [requestStatus]);

    useEffect(() => {
        if (id) {
            dispatch(getCurrentInquiry({ id: parseInt(id) }));
        }
    }, [id]);

    const handleCancel = () => {
        navigate(-1);
    };

    // @ts-ignore
    const formik = useFormik({
        initialValues: {
            comment: inquiriesState?.currentInquiry?.comment ?? ""
        },
        onSubmit: (values: any) => {
            dispatch(markAnswered({ id, data: values }));
        },
        enableReinitialize: true
    });

    const {values, setFieldValue, handleSubmit} = formik;

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks} />
            {requestStatus === RequestStatus.Failed &&
            inquiriesState.errors.length > 0 && (
                <div className="message msg-error">
                    <div>
                        <h2>Viga:</h2>
                        {inquiriesState.errors.map((error, index) => (
                            <span key={index}>{error}<br /></span>
                        ))}
                    </div>
                </div>
            )}
            <FormikProvider value={formik}>
                <Form onSubmit={handleSubmit}>
                    <div className="form">
                        <h2>
                            <span>Päringu andmed</span>
                        </h2>
                        <table className="form">
                            <tbody>
                            <ElogTextarea label="Kommentaar / Ost põhineb" name="comment"/>
                            </tbody>
                        </table>
                    </div>
                    <div className="action clear">
                        <p>
                            <button type="submit">
                  <span>
                    <strong>Muuda</strong>
                  </span>
                            </button>
                            <button type="button" onClick={handleCancel}>
                                Tühista
                            </button>
                        </p>
                    </div>
                </Form>
            </FormikProvider>
        </LoggedInView>
    );

}